import { useTranslation } from 'react-i18next';
import { Content } from './page-error.styled';

export const PageError = () => {
  const { t } = useTranslation();

  return (
    <Content>
      {t('errors.Произошла ошибка')} <br />
      {t('errors.Обратитесь в службу технической поддержки')}
    </Content>
  );
};
